import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnChanges,ViewChild } from '@angular/core';
import { PatientService } from '@service/patient.service';
import { FormControl, Validators, FormGroup, FormBuilder, FormGroupDirective, NgForm } from '@angular/forms';
import { PatientInsurance, PatientDetailMaster, PatientContact, Patient, PatientAttachment,InsurancePayer } from '@models/appointments/patient.model';
import { RoutingHelper } from '@helpers/routinghelper';
import { Router, ActivatedRoute } from '@angular/router';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import * as moment from 'moment';
import { ErrorStateMatcher } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import * as _ from 'underscore';
import { BeyondEMRHelper } from '../../../helpers/beyondemr-helper';
import { ValueAccessorHelper } from '../../../helpers/value-accessor-helper';
import { MatSelect } from '@angular/material/select';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid);
    const invalidParent = !!(control && control.parent && control.parent.invalid);

    return (invalidCtrl || invalidParent);
  }
}

@Component({
  selector: 'app-insurance-form-dialog',
  templateUrl: './insurance-form.component.html',
  styleUrls: ['./insurance-form.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class InsuranceFormComponent extends ValueAccessorHelper<any> implements OnInit, OnChanges {
  public action: string;
  public dialogTitle: string;
  patient: Patient;
  insuranceItem: PatientInsurance;
  masters: PatientDetailMaster;
  index: number;
  isActive = false;
  disabled = false;
  responsible: '';
  insuredname
  country: string;
  firstname:string;
  dob: string;
  state: '';
  city: '';
  zip: '';
  file: any;
  files: Array<any> = new Array<any>();
  apiURL: string = '';
  dbName: string;
  beyondEMRConstants: any;
  startDate: Date;
  endDate: Date;
  genderIdentity: string;
  insuranceProvider: '';
  public countryOptions = [];
  @ViewChild(MatSelect) matSelect: MatSelect;

  constructor(
    public dialogRef: MatDialogRef<InsuranceFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public patientService: PatientService,
    private router: Router,
    private datePipe: DatePipe,
    private cdf: ChangeDetectorRef,
    private helper: BeyondEMRHelper,
    private route?: ActivatedRoute,
    private routingHelper?: RoutingHelper
  ) {

    super();
    // Set the defaults
    this.action = data.action;
    dialogRef.disableClose = true;
    this.beyondEMRConstants = BeyondEMRConstants;

    this.masters = data.masters;
    let id = this.routingHelper.GetRoutingParamerterId(this.route.params);
    this.bindMasters(id);
    this.country = this.helper.filterByMaster(data.patient.Contact.CountryId, this.masters?.Country, 'DisplayName');

    if (this.action === 'edit') {
      this.dialogTitle = 'Edit Insurance';
      this.patient = data.patient;
      this.index = data.index;
      this.insuranceItem = this.patient.Insurance[this.index];
      this.state = this.filterByMaster(this.insuranceItem.InsuranceContact.StateId, this.masters?.State);
      this.city = this.filterByMaster(this.insuranceItem.InsuranceContact.CityId, this.masters?.City);
      this.zip = this.filterByMaster(this.insuranceItem.InsuranceContact.ZipId, this.masters?.ZipCode, 'Name');
      this.country = this.helper.filterByMaster(data.patient.Contact.CountryId, this.masters?.Country, 'DisplayName');
      this.insuranceItem.StartDate = this.datePipe.transform(this.insuranceItem.StartDate, 'yyyy-MM-ddTHH:mm:ss');
      this.insuranceItem.EndDate = this.datePipe.transform(this.insuranceItem.EndDate, 'yyyy-MM-ddTHH:mm:ss');
      this.insuranceProvider = this.filterByMaster(this.insuranceItem.InsuranceProviderId, this.masters?.InsurancePayer);
      this.insuranceItem.InsuranceContact.DOB = this.datePipe.transform(this.insuranceItem.InsuranceContact.DOB, 'yyyy-MM-dd');
      this.firstname = this.filterByMaster(this.insuranceItem.InsuranceContact.FirstName,this.masters?.FirstName);
      this.genderIdentity = this.filterByMaster(this.insuranceItem.InsuranceContact.GenderId, this.masters?.Gender); 
    }
    else {
      this.dialogTitle = 'Add Insurance';
      this.patient = data.patient;
      this.index = data.index;
      this.insuranceItem = new PatientInsurance();
      this.insuranceItem.InsuranceContact = new PatientContact();
    }

    this.apiURL = data.apiURL;
    this.dbName = data.dbName;
  }

  ngOnInit() {
    this.cdf.detectChanges();
  }

  ngOnChanges() {
    this.cdf.detectChanges();
  }
  
  checkDates(formElement: NgForm) {
    if (this.insuranceItem.EndDate) {
      let startDate = new Date(this.insuranceItem.StartDate);
      let endDate = new Date(this.insuranceItem.EndDate);
      if ((startDate != null && endDate && (endDate < startDate))) {
        formElement.controls['endDate'].setErrors({ 'incorrect': true });

        let that = this;
        setTimeout(function () { that.helper.scrollToFirstInvalidControl(); }, 5);

        return false;
      }
    }
    return true;
  }
  onNoClick(): void {
    if (this.action === this.beyondEMRConstants.ActionType.ADD) {
      this.patient.Insurance.splice(this.index, 1);
    }
    this.dialogRef.close();
  }

  public confirmAdd(formElement: NgForm) {
    let that = this;
    if (formElement.invalid || !this.validateTypeahead(formElement)) {
      setTimeout(function () { that.helper.scrollToFirstInvalidControl(); }, 5);
      return false;
    }
    else if (this.checkDates(formElement) == true) {
      this.insuranceItem.StartDate = this.datePipe.transform(this.insuranceItem.StartDate, "MM/dd/yyyy");
      this.insuranceItem.EndDate = this.datePipe.transform(this.insuranceItem.EndDate, "MM/dd/yyyy");
      this.insuranceItem.InsuranceContact.ContactTypeId = BeyondEMRConstants.ContactType.Insurance_Address;
      this.patient.Insurance[this.index] = this.insuranceItem;
      var primaryInsurance = this.patient.Insurance.find(x => x.Active == true && x.IsPrimary == true && x.Id != this.insuranceItem.Id);

      this.patient.Insurance[this.index].IsPrimary = primaryInsurance != null ? false : true;
      if (this.patient.Insurance[this.index].IsPrimary == true) {
        _.each(this.patient.Insurance, function (x, i) {
          if (i != that.index) {
            x.IsPrimary = false;
          }
        })
      }
      this.saveInsurance();
    }

    return false;
  }

  addUploadFiles() {
    this.patient?.ProfileAttachment?.File ? this.files.push(this.patient.ProfileAttachment?.File) : '';
    if (this.patient?.Insurance?.length > 0) {
      for (let i = 0; i < this.patient.Insurance.length; i++) {
        this.patient.Insurance[i].InsuranceContact.DOB = this.datePipe.transform(this.patient.Insurance[i].InsuranceContact.DOB, "MM/dd/yyyy");
        if (this.patient.Insurance[i].EndDate && this.patient.Insurance[i].EndDate.toLocaleLowerCase() == 'invalid date') {
          this.patient.Insurance[i].EndDate = '';
        }
        if (this.patient.Insurance[i].InsuranceAttachment) {
          for (let j = 0; j < this.patient?.Insurance[i]?.InsuranceAttachment.length; j++) {
            if (this.patient?.Insurance[i]?.InsuranceAttachment[j]) {
              this.patient?.Insurance[i]?.InsuranceAttachment[j]?.File ? this.files.push(this.patient?.Insurance[i]?.InsuranceAttachment[j]?.File) : '';
            }
          }
        }
      }
    }
  }

  saveInsurance() {
    this.addUploadFiles();
    this.dialogRef.close(this.patient);   
  } 

  filterByMaster(id, master, column?): any {
    if (id > 0) {
      column = column ? column : 'DisplayName';
      var result = master?.find(x => x.Id == id);
      return result ? result[column] : '';
    }   
  }

  filterIdByMaster(name, master): any {
    if (name.value) {
      var result = master?.find(x => x.DisplayName == name.value);
      return result ? result['Id'] : '';
    }
  }  

  onChangeCountry(item) {
    this.insuranceItem.InsuranceContact.CountryId = item && item['Id'] || 0;
    this.insuranceItem.InsuranceContact.StateId = 0;
    this.insuranceItem.InsuranceContact.CityId = 0;
    this.state = '';
    this.city = '';
    this.zip = '';
  }

  onChangeZip(item) {
    this.insuranceItem.InsuranceContact.ZipId = item && item['Id'] || 0;
    this.zip = item && item['Name'] || '';
    this.insuranceItem.InsuranceContact.CityId = this.insuranceItem.InsuranceContact.ZipId > 0 ? <any>this.masters?.ZipCode.filter(item => item.Id === this.insuranceItem.InsuranceContact.ZipId)[0].CityId : '';
    this.city = this.insuranceItem.InsuranceContact.CityId > 0 ? <any>this.masters?.City.filter(item => item.Id === this.insuranceItem.InsuranceContact.CityId)[0].DisplayName : '';
    this.insuranceItem.InsuranceContact.StateId = this.insuranceItem.InsuranceContact.CityId > 0 ? <any>this.masters?.City.filter(item => item.Id === this.insuranceItem.InsuranceContact.CityId)[0].StateId : '';
    this.state = this.insuranceItem.InsuranceContact.StateId > 0 ? <any>this.masters?.State.filter(item => item.Id === this.insuranceItem.InsuranceContact.StateId)[0].DisplayName : '';
  }

  onChangeGenderIdentity(item) {
    this.insuranceItem.InsuranceContact.GenderId = item && item['Id'] || 0;
  }

  onChangeState(item) {
    this.insuranceItem.InsuranceContact.StateId = item && item['Id'] || 0;
    this.city = '';
    this.zip = '';
  }

  onChangeCity(item) {
    this.insuranceItem.InsuranceContact.CityId = item && item['Id'] || 0;
    this.zip = '';
  }

  onChangePreferredContact(item) {
    this.insuranceItem.InsuranceContact.PreferredContactId = this.filterIdByMaster(item, this.masters.PreferredContact);
  }

  onChangeEmail(event) {
    this.insuranceItem.InsuranceContact.EmailId = event ? event : '';
  }

  insuranceFileUploadFrontChange(fileValue) {  
    let attachmet = new PatientAttachment();
    let existing = this.insuranceItem?.InsuranceAttachment?.find(i => i.RowOrder === 1);
    if (existing) {
      this.insuranceItem.InsuranceAttachment = this.insuranceItem?.InsuranceAttachment?.filter(i => i.RowOrder !== 1);
      existing.UploadFileName = fileValue.name;
      existing.DisplayName = fileValue.name.split('.')[0];
      existing.UploadFilePath = "Insurance";
      existing.File = fileValue;
      existing.RowOrder = existing?.RowOrder ? existing.RowOrder : 1;
      existing.Active = true;
      existing.DirtyAttachment = true;
      this.insuranceItem.InsuranceAttachment.push(existing);
    }
    else {
      attachmet.UploadFileName = fileValue.name;
      attachmet.DisplayName = fileValue.name.split('.')[0];
      attachmet.PatientId = this.patient.Id;
      attachmet.AttachmentTypeId = this.masters.AttachmentType.find(i => i.EnumName == 'Insurance')?.Id;
      attachmet.UploadFilePath = "Insurance";
      attachmet.File = fileValue;
      attachmet.RowOrder = 1;
      attachmet.DirtyAttachment = true;
      attachmet.Active = true;
      if (this.insuranceItem != null) {
        this.insuranceItem.InsuranceAttachment = this.insuranceItem?.InsuranceAttachment?.filter(i => i.RowOrder != attachmet.RowOrder);
        this.insuranceItem.InsuranceAttachment.push(attachmet);
      }
    }
    this.insuranceSetUploadFile(1, this.insuranceItem?.InsuranceAttachment);
    this.insuranceFileUploadShow(1, this.insuranceItem?.InsuranceAttachment);   
  }

  insuranceFileUploadBackChange(fileValue) {
    let attachmet = new PatientAttachment();
    let existing = this.insuranceItem?.InsuranceAttachment?.find(i => i.RowOrder === 2);
    if (existing) {
      this.insuranceItem.InsuranceAttachment = this.insuranceItem?.InsuranceAttachment?.filter(i => i.RowOrder !== 2);
      existing.UploadFileName = fileValue.name;
      existing.DisplayName = fileValue.name.split('.')[0];
      existing.UploadFilePath = "Insurance";
      existing.File = fileValue;
      existing.RowOrder = existing?.RowOrder ? existing.RowOrder : 2;
      existing.Active = true;
      existing.DirtyAttachment = true;
      this.insuranceItem.InsuranceAttachment.push(existing);
      this.insuranceItem.InsuranceAttachment.push(existing);
    }
    else {
      attachmet.UploadFileName = fileValue.name;
      attachmet.DisplayName = fileValue.name.split('.')[0];
      attachmet.PatientId = this.patient.Id;
      attachmet.AttachmentTypeId = this.masters.AttachmentType.find(i => i.EnumName == 'Insurance')?.Id;
      attachmet.UploadFilePath = "Insurance";
      attachmet.File = fileValue;
      attachmet.RowOrder = 2;
      attachmet.DirtyAttachment = true;
      attachmet.Active = true;
      if (this.patient?.Insurance?.length > 0) {
        this.insuranceItem.InsuranceAttachment = this.insuranceItem?.InsuranceAttachment?.filter(i => i.RowOrder != attachmet.RowOrder);
        this.insuranceItem.InsuranceAttachment.push(attachmet);
      }
    }
    this.insuranceSetUploadFile(2, this.insuranceItem?.InsuranceAttachment);
    this.insuranceFileUploadShow(2, this.insuranceItem?.InsuranceAttachment);   
  }

  insuranceSetUploadFile(rowOrder, attachments) {
    let result = attachments.find(i => i.RowOrder == rowOrder && i.Active == true)?.DisplayName;
    return result ? result : '';
  }

  insuranceFileUploadShow(rowOrder, attachments) {
    let result = attachments.find(i => i.RowOrder == rowOrder && i.Active == true)?.UploadFileName;
    return result ? true : false;
  }

  insuranceShowFile(rowOrder, attachments) {
    let result = attachments.find(i => i.RowOrder == rowOrder && i.Active == true);
    if (result?.DirtyAttachment != true) {
      this.patientService.GetFiles(this.apiURL + 'patient/DownloadPatientAttachment/' + result?.Id, this.dbName).subscribe(res => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
      });
    }
  }

  insuranceRemoveFile(rowOrder) {
    for (let i = 0; i < this.insuranceItem.InsuranceAttachment?.length; i++) {
      if (this.insuranceItem.InsuranceAttachment[i]?.Id > 0) {
        if (this.insuranceItem.InsuranceAttachment[i]?.RowOrder === rowOrder) {
          this.insuranceItem.InsuranceAttachment[i].Active = false;
        }
      }
      else {
        this.insuranceItem.InsuranceAttachment = this.insuranceItem.InsuranceAttachment.filter(j => j.RowOrder !== rowOrder);
      }
    }
  }

  bindMasters(id) {
    let isCreate = id > 0 ? false : true;
    this.masters.ContactType = this.helper.bindMaster(this.masters.ContactType, isCreate, this.insuranceItem?.RelationshipId);
    this.masters.Country = this.helper.bindMaster(this.masters.Country, isCreate, this.insuranceItem?.InsuranceContact?.CountryId);
    this.masters.City = this.helper.bindMaster(this.masters.City, isCreate, this.insuranceItem?.InsuranceContact?.CityId);
    this.masters.State = this.helper.bindMaster(this.masters.State, isCreate, this.insuranceItem?.InsuranceContact?.StateId);
    this.masters.ZipCode = this.helper.bindMaster(this.masters.ZipCode, isCreate, this.insuranceItem?.InsuranceContact?.ZipId);
  }

  onChangeInsurance(item) {
    
    this.insuranceItem.InsuranceProviderId = item && item['Id'] || 0;
    this.insuranceItem.CompanyName = this.filterByMaster(this.insuranceItem.InsuranceProviderId, this.masters?.InsurancePayer, 'DisplayName'); 
   }

  ngAfterViewInit() {
    this.matSelect.openedChange.subscribe(opened => {
      if (opened) {
        this.matSelect.panel.nativeElement.addEventListener('mouseleave', () => {
          this.matSelect.close();
        })
      }
    })
  }

  validateTypeahead(formElement: NgForm): boolean {
    let result = true;

    if (this.country && this.insuranceItem.InsuranceContact.CountryId <= 0 || !this.insuranceItem.InsuranceContact.CountryId) {
      formElement.controls['countryName'].setErrors({ 'incorrect': true });
      result = false;
    }
    if (this.zip && this.insuranceItem.InsuranceContact.ZipId <= 0 || !this.insuranceItem.InsuranceContact.ZipId) {
      formElement.controls['zipCode'].setErrors({ 'incorrect': true });
      result = false;
    }
    if (this.state && this.insuranceItem.InsuranceContact.StateId <= 0 || !this.insuranceItem.InsuranceContact.StateId) {
      formElement.controls['stateName'].setErrors({ 'incorrect': true });
      result = false;
    }
    if (this.city && this.insuranceItem.InsuranceContact.CityId <= 0 || !this.insuranceItem.InsuranceContact.CityId) {
      formElement.controls['cityName'].setErrors({ 'incorrect': true });
      result = false;
    }

    return result;
  }
}
